// extracted by mini-css-extract-plugin
export var secondaryNavigation = "SecondaryNavigation-module--secondaryNavigation--5eb24";